var TAresourcegrid = (function($) {
    'use strict';

    var $menuCtrlLeft = $('.control.left');
    var $menuCtrlRight = $('.control.right');
    var $menuWrapper = $('.wrapper-menu');

    function init() {
        $(document).ready(function() {
            events();
        });
    }

    function events() {
        if($menuCtrlLeft.length) {
            $menuCtrlLeft.on('click', function(event) {
                $menuWrapper.animate({ scrollLeft: '-=150px' }, 500);
                event.preventDefault();
            });
        }

        if($menuCtrlRight.length) {
            $menuCtrlRight.on('click', function(event) {
                $menuWrapper.animate({ scrollLeft: '+=150px' }, 500);
                event.preventDefault();
            });
        }
    }

    return {
        init: init
    };
}(jQuery));